import React, { useState, useEffect } from 'react';
import { attributionAPI } from '../../../services/api';

const formatValue = (v) => {
  if (v === null || v === undefined) return '—';
  if (typeof v !== 'number') return v;
  if (!isFinite(v)) return '—';
  return v.toFixed(2);
};

const SummaryStats = ({ portfolioCode, reportType, periodEnd, rangeStart, rangeEnd }) => {
  const [stats, setStats] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!portfolioCode) return;

    if (reportType === 'RANGE') {
      if (!rangeStart || !rangeEnd) return;
      setLoading(true);
      attributionAPI.getRangeKeyStats(portfolioCode, { start_date: rangeStart, end_date: rangeEnd })
        .then((data) => { setStats(data); setLoading(false); })
        .catch((err) => { console.error('Failed to load range stats', err); setLoading(false); });
      return;
    }

    setLoading(true);
    const params = { report_type: reportType };
    if (reportType !== 'SI' && periodEnd) params.period_end = periodEnd;

    const requests = [attributionAPI.getKeyStats(portfolioCode, params)];
    if (reportType === 'SI') {
      requests.push(attributionAPI.getAnnualisedReturn(portfolioCode));
    }

    Promise.all(requests)
      .then((results) => {
        const rawStats = results[0];
        const annualised = results[1];
        if (annualised) {
          setStats([
            {
              statistic_name: 'Annualised Return',
              portfolio: annualised.portfolio,
              benchmark: annualised.benchmark,
              difference: annualised.difference,
            },
            ...rawStats,
          ]);
        } else {
          setStats(rawStats);
        }
        setLoading(false);
      })
      .catch((err) => { console.error('Failed to load stats', err); setLoading(false); });
  }, [portfolioCode, reportType, periodEnd, rangeStart, rangeEnd]);

  if (loading) return <div className="stats-loading">Loading…</div>;
  if (!stats.length) return <div className="stats-empty">No statistics available.</div>;

  return (
    <table className="stats-table">
      <thead>
        <tr>
          <th>Statistic</th>
          <th className="num">Portfolio</th>
          <th className="num">Benchmark</th>
          <th className="num">Diff</th>
        </tr>
      </thead>
      <tbody>
        {stats.map((s) => (
          <tr key={s.statistic_name}>
            <td>{s.statistic_name}</td>
            <td className="num">{formatValue(s.portfolio)}</td>
            <td className="num">{formatValue(s.benchmark)}</td>
            <td className="num">{formatValue(s.difference)}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default SummaryStats;
